var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunblock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pgdgilrhca)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.773 77.168H8.554v-5.492L0 14.434V.176h51.328l-.03 14.683-8.525 56.817v5.492z",
    fill: "#ECCE93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.22 91.426H17.11c-4.716 0-8.555-3.839-8.555-8.555V71.676h34.219V82.87c0 4.716-3.839 8.555-8.555 8.555z",
    fill: "#F78659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.258 22.988H37.07v5.704H14.258v-5.704zM37.07 40.097h-5.703v-5.703h5.703v5.703zm-11.406 0H14.258v-5.703h11.406v5.703z",
    fill: "#BF841B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.966 37.066 33.53 51.504 44.2 62.174l3.766-25.108z",
    fill: "#E5BA6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.142 68.614v7.374L49.658 51.505l9.39-9.391-4.032-4.032-13.422 13.423L70.11 80.02h-7.374v5.703h17.11v-17.11h-5.704z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.935 17.285.362-2.426.009-3.277H0v2.851l.425 2.852h50.51z",
    fill: "#E5BA6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.22 85.723H17.11c-4.716 0-8.555-3.838-8.555-8.555v5.704c0 4.716 3.839 8.554 8.555 8.554h17.11c4.715 0 8.554-3.838 8.554-8.554v-5.704c0 4.717-3.839 8.555-8.555 8.555z",
    fill: "#EF6B47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.703 5.879h5.704v5.704H5.703V5.878zM17.11 5.879h5.702v5.704H17.11V5.878zM39.922 5.879h5.704v5.704h-5.704V5.878z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.16 17.563c.929-1.7 2.263-3.128 3.898-4.17h-.003L63.589 9.22l-3.896 4.166 4.466 4.178c.003 0 .003-.003 0 0zM73.758 11.587c.99-.034 1.94.103 2.867.311l-.206-6.105-5.7.19.205 6.106c.904-.268 1.845-.468 2.834-.502zM83.733 16.907c0-.003 0-.003 0 0l4.175-4.469-4.166-3.895-4.175 4.466h-.002a11.366 11.366 0 0 1 4.168 3.898zM63.241 26.207c-.268-.91-.467-1.848-.502-2.837-.034-.99.103-1.94.311-2.866l-6.105.208.191 5.7 6.105-.205zM64.546 29.07l-4.175 4.468 4.166 3.896 4.175-4.466h.003a11.419 11.419 0 0 1-4.17-3.898zM84.12 28.412a11.44 11.44 0 0 1-3.897 4.169h.002l4.466 4.174 3.895-4.165-4.465-4.178c-.003.003-.003 0 0 0zM85.04 19.768c.267.908.467 1.846.498 2.838.034.99-.103 1.94-.31 2.866l6.104-.205-.19-5.7-6.103.201zM74.522 34.388c-.99.035-1.939-.103-2.866-.31l.206 6.105 5.7-.191-.206-6.105c-.903.27-1.844.467-2.834.501z",
    fill: "#FFCB5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.695 22.988a8.555 8.555 0 1 1-17.11 0 8.555 8.555 0 0 1 17.11 0z",
    fill: "#FF6853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pgdgilrhca"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h91.333v91.333H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunblock);
export default __webpack_public_path__ + "static/media/sunblock.d0da565c039ed9ed95cf4c7ca40450b0.svg";
export { ForwardRef as ReactComponent };